import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {TransferImage} from '@app/components/Assets/TransferImage';

export const TransferSection: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t('featureslandingpage_title_transferyourlibrary_standalone-web', {
							ns: 'features',
						})}
					</LandingHeading>

					<LandingParagraph>
						{t('featureslandingpage_text_transferyourlibrary_standalone-web', {
							ns: 'features',
						})}
					</LandingParagraph>
				</>
			}
			image={<TransferImage w={{base: '300px', md: '800px'}} />}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'tune-my-music'}}
					href="/features/transfer-playlist"
				>
					{t('generic_action_discovermore_standalone-web', {ns: 'common'})}
				</LandingButtonLink>
			}
		/>
	);
};
